interface Attributes {
  email: string;
  userId: string;
  [x: string]: any;
}

const setCrashAnalytics = (log: string, attributes: Attributes) => {};

export default setCrashAnalytics;
